import {
    ComparisonTypeEnum,
    ConditionLineTypeEnum,
    ConditionOptionsBase,
    ElementUsedTypeEnum,
    ShowHideConditionOptions,
    SubTypeEnum
} from "../../Fields/Core/ConditionOptions";
import {FBFieldBase} from "../../Fields/Core/FBFieldBase";
import {MultipleValueRetriever} from "../ValueRetriever/MultipleValueRetriever";
import {FormBuilderSource} from "../ValueRetriever/Core/FormBuilderSource";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";

export abstract class ConditionProcessorBase {
    public Options:ConditionOptionsBase;
    public FormBuilder:ContainerDataRetriever;
    public LastResult:boolean;

    public GetExecuteOnFieldChange(){
        return true;
    }

    public GetExecuteOnInitialize(){
        return true;
    }

    public Initialize(formBuilder:ContainerDataRetriever,condition:ConditionOptionsBase)
    {
        this.FormBuilder=formBuilder;
        this.LastResult=null;
        this.Options=condition;

        if(this.GetExecuteOnFieldChange()) {
            for (let usedField of condition.ElementsUsed) {
                if (usedField.Type == ElementUsedTypeEnum.Field) {
                    let fieldUsed = this.FormBuilder.ContainerManager.GetFieldById(usedField.Id, false, true);
                    fieldUsed.ValueChanged.Subscribe(this, x => this.ExecuteCondition())

                }

                if (usedField.Type == ElementUsedTypeEnum.Variation) {
                    this.FormBuilder.VariationChanged.Subscribe(this, x => this.ExecuteCondition());
                }
            }
        }
        if(this.GetExecuteOnInitialize())
            this.ExecuteCondition(true);
        return this;
    }

    ExecuteCondition(immediate:boolean=false) {
        let result=this.ProcessCondition();
        if(this.LastResult===result)
            return;

        this.LastResult=result;

        if(result)
            this.ExecuteTruAction(immediate);
        else
            this.ExecuteFalseAction(immediate);
    }

    abstract ExecuteTruAction(immediate:boolean);
    abstract ExecuteFalseAction(immediate:boolean);



    private ProcessCondition() {
        for(let group of this.Options.ConditionGroups){
            let groupIsValid=true;
            for(let line of group.ConditionLines)
            {
                if(!groupIsValid)
                    break;
                let result=null;
                switch (line.Type) {
                    case ConditionLineTypeEnum.Standard:
                        let field=this.FormBuilder.ContainerManager.GetFieldById(line.FieldId,false,true);
                        if(field==null) {
                            continue;
                        }


                        groupIsValid=field.ValueRetriever.Compare(line.Comparison,line.Value);

                        break;
                    case ConditionLineTypeEnum.Variation:
                        let variation= new MultipleValueRetriever(new FormBuilderSource(this.FormBuilder,line.FieldId));

                        groupIsValid=variation.Compare(line.Comparison,line.Value);
                        break;
                }

            }

            if(groupIsValid)
                return true;
        }
        return false;
    }

}